import React, { useCallback, useState } from "react";

const SearchBar = (props) => {
  // SerachBar 기본 필드

  const [initFields, setInitFields] = useState({
    schAuthId: "",
    schAuthNm: "",
  });

  const handleChangeField = useCallback((event) => {
    const { name, value } = event.target;

    setInitFields({ ...initFields, [name]: value });
    props.setSearchParameters({ ...initFields, [name]: value });
  });

  return (
    <>
      <div className="searchdata">
        <ul>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font>권한아이디
            </div>
            <input
              type="text"
              className="datainput"
              name="schAuthId"
              onChange={handleChangeField}
              value={initFields.schAuthId}
            />
          </li>
          <li>
            <div className="divide50">
              <font color="grey">⦁</font> 권한명
            </div>
            <input
              type="text"
              className="datainput"
              name="schAuthNm"
              onChange={handleChangeField}
              value={initFields.schAuthNm}
            />
          </li>
        </ul>
      </div>
    </>
  );
};

export default React.memo(SearchBar);
